<template>
  <div class="headbar flex-between flex-wrap" :style="{ height: suspend ? 'auto': '80px' }">
    <div class="flex items-center">
      <img
        data-cy="sidemenu-toggle-btn"
        style="cursor: pointer; margin-right: 24px"
        src="@/assets/icon/menu.svg"
        alt=""
        @click.stop="toggleSideBar"
      >
      <img
        :src="gimmatekLogo"
        :srcset="`${gimmatekLogo} 1x, ${gimmatekLogo2x} 2x`"
        alt="GIMMATEK"
        class="brand"
        @click="toggleSideBar"
      >
      <div class="version flex-align-end">
        <p data-cy="app-version">v {{ version }}</p>
        <DevOnly>
          <el-tag :type="appRuntime.tagType">{{ appRuntime.name }}</el-tag>
        </DevOnly>
      </div>
    </div>

    <div class="right-menu">
      <!-- 掃描器QRCode -->
      <div v-if="showQrcode" class="scan-qrcode" @click="qrcode.visible = true">
        <img src="@/assets/member/icon-scan-qrcode.svg" alt="Scan QRCode icon">
      </div>
      <!-- 外接掃描器會員查詢 -->
      <ScannerButton v-if="showScannerButton" />
      <DevOnly>
        <BaseElButton v-if="usePermissionsDebugger" type="info" @click="toggleFeatureKeyDebugger">🔰 權限控制面板</BaseElButton>
      </DevOnly>
      <DevOnly>
        <BaseElButton type="info" @click="bugReportModalVisible = true">回報錯誤</BaseElButton>
      </DevOnly>
      <DevOnly>
        <HeadbarAccountSwitcher />
      </DevOnly>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
        placement="bottom-start"
      >
        <div class="avatar-wrapper">
          <p class="username">
            {{ user.name || '' }}
            <i class="el-icon-arrow-down" style="margin-left: 13px;" />
          </p>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div>
              <router-link
                style="display:block;"
                :to="{ name: 'AccountConfig' }"
              >
                個人帳號設定
              </router-link>
            </div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="showSystemInfo">
            <div>
              <span style="display:block;">系統資訊</span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <div>
              <span style="display:block;">登出</span>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-if="enableMultilingual" class="locale-changer">
        <el-select v-model="selectedLang">
          <el-option
            v-for="(lang, i) in langs"
            :key="`Lang${i}`"
            :label="lang.label"
            :value="lang.value"
          />
        </el-select>
      </div>
    </div>
    <!--    <div>-->
    <!--      <el-menu mode="horizontal" menu-trigger="click">-->
    <!--        <el-submenu index="1" style="background: white;">-->
    <!--          <template slot="title">{{user.name}}</template>-->
    <!--          <el-menu-item index="1-1" align="center">-->
    <!--            <div @click="accountSetting = true">個人帳號設定</div>-->
    <!--          </el-menu-item>-->
    <!--          <el-menu-item index="1-1" align="center" @click.native="logout">-->
    <!--            <span style="display:block;">登出</span>-->
    <!--          </el-menu-item>-->
    <!--        </el-submenu>-->
    <!--      </el-menu>-->
    <!--    </div>-->

    <!-- QRCode Reader (moved to QRCodeReaderModal component) -->
    <QRCodeReaderModal
      v-if="qrcode.visible"
      :reload="reloadQrcode"
      :init="qrcode.init"
      @init="onInit"
      @decode="onDecode"
      @close="qrcode.visible = false"
    />
    <!-- suspend -->
    <SuspendNotice v-if="suspend" class="suspend" :title="suspendNotice" />
    <BugReportModal
      v-if="bugReportModalVisible"
      @close="bugReportModalVisible = false"
    />
    <SystemInfoDialog
      v-if="systemInfoDialogVisible"
      @close="systemInfoDialogVisible = false"
    />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import { mapGetters } from 'vuex'
import gimmatekLogo from '@/assets/header/logo-gimmatek.png'
import gimmatekLogo2x from '@/assets/header/logo-gimmatek-2x.png'
import { FindShopMember } from '@/api/auth'
import { FindMember } from '@/api/member'
import { getAppVersion } from '@/utils/app'
import QRCodeReaderModal from '@/components/QRCodeReaderModal.vue'
import { usePermissions } from '@/use/permissions'
import { FindShutDownNotice } from '@/api/shutdown'
import SuspendNotice from '@/components/SuspendNotice.vue'
import BugReportModal from '@/components/BugReportModal.vue'
import SystemInfoDialog from './SystemInfoDialog.vue'
import { ScannerButton } from '@/components/Scanner'
import { isEmpty, get } from 'lodash'
import store from '@/store'
import { loadLanguageAsync, i18n } from '@/plugins/i18n/i18n'
import configuration from '@/configuration'
import HeadbarAccountSwitcher from './HeadbarAccountSwitcher.vue'

export default defineComponent({
  name: 'Headbar',
  components: { QRCodeReaderModal, SuspendNotice, BugReportModal, SystemInfoDialog, ScannerButton, HeadbarAccountSwitcher },
  setup () {
    const { checkAction } = usePermissions()
    const usePermissionsDebugger = computed(() => get(store.getters, 'app/useSidebarSearch'))
    const enableMultilingual = computed(() => get(store.state, 'org.enableMultilingual'))
    const bugReportModalVisible = ref(false)
    const systemInfoDialogVisible = ref(false)
    const appRuntime = computed(() => {
      const runTime = configuration('appRuntime') || ''

      const runTimeTagType = {
        dev: 'action',
        uat: 'success',
      }

      return {
        tagType: get(runTimeTagType, runTime.toLowerCase(), 'info'),
        name: runTime ? runTime.toUpperCase() : '-',
      }
    })

    const reloadQrcode = ref(false)

    // const selectedLang = ref(i18n.locale)
    const selectedLang = computed({
      get: () => i18n.locale,
      set: (value) => {
      // 動態載入新語言
        loadLanguageAsync(value)
          .then(() => {
            console.log(`Language switched to: ${value}`)
          })
          .catch((error) => {
            console.error('Failed to switch language:', error)
          })
      },
    })
    const toggleFeatureKeyDebugger = () => {
      store.commit('app/SET_TOGGLE', { key: 'featureKeyDebugger', toggle: true })
    }
    const suspend = ref(false)
    const suspendNotice = ref('')
    const getShutDownNotice = async () => {
      const [res, err] = await FindShutDownNotice()
      if (err) window.$message.error(err)
      if (res && !isEmpty(res)) {
        suspend.value = true
        suspendNotice.value = get(res[0], 'title')
      }
    }
    onMounted(async () => {
      await getShutDownNotice()
    })

    return {
      checkAction,
      reloadQrcode,
      suspend,
      suspendNotice,
      usePermissionsDebugger,
      toggleFeatureKeyDebugger,
      selectedLang,
      appRuntime,
      enableMultilingual,
      i18n,
      bugReportModalVisible,
      systemInfoDialogVisible,
    }
  },
  data: () => ({
    selectShop: '',
    gimmatekLogo,
    gimmatekLogo2x,

    // -- QRCode
    qrcode: {
      init: true,
      visible: false,
      decodedString: '',
    },
    langs: [
      {
        label: '繁體中文',
        value: 'zh',
      },
      {
        label: 'English',
        value: 'en',
      },
      {
        label: '日本語',
        value: 'jp',
      },
      {
        label: '한국어',
        value: 'kr',
      },
    ],
  }),
  computed: {
    ...mapGetters([
      'shop',
      'userPlanFeature',
    ]),
    version () {
      return getAppVersion()
    },
    sidebar () {
      return this.$store.getters.sidebar
    },

    user () {
      return this.$store.getters.user || {}
    },
    isFeatureScanQrcodeValid () {
      return this.userPlanFeature['admin.base.scanQrcode']
    },

    showQrcode () {
      if (this.checkAction('admin.memberCenterQRcode.page') || this.checkAction('admin.base.scanQrcode')) {
        if (this.$route.meta.disabledQrcodeReader) {
          return false
        }
        return true
      }
      return false
    },

    showScannerButton () {
      if (this.checkAction('admin.memberCenterQRcode.page') || this.checkAction('admin.base.scanQrcode')) {
        if (this.$route.meta.disabledQrcodeReader) {
          return false
        }
        return true
      }
      return false
    },
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('app/toggleSidebar')
    },
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    },

    showSystemInfo () {
      this.systemInfoDialogVisible = true
    },

    goProfile (id) {
      this.$router.push({ path: `/members/member-profile/${id}` })
    },

    async onInit (promise) {
      this.qrcode.init = true
      try {
        await promise
      } catch (error) {
        console.log('qrcode error', error)
      } finally {
        this.qrcode.init = false
      }
    },

    async onDecode (decodedString) {
      this.qrcode.decodedString = decodedString.split(':')
      this.qrcode.visible = false

      // 支援 bob:member:{id} 格式
      if (this.qrcode.decodedString[0] === 'bob' && this.qrcode.decodedString[1] === 'member') {
        await FindShopMember({
          shopId: this.shop,
          id: this.qrcode.decodedString[2],
        })
          .then((response) => {
            const [res, err] = response

            if (res) {
              this.$message.success('此為店家會員')
              this.goProfile(this.qrcode.decodedString[2])
            }
            if (err) this.$message.error('非店家會員')
          })

        return
      }

      // 支援手機號碼格式（09 開頭，總共 10 碼）
      const phoneMatch = decodedString && decodedString.match(/^09\d{8}$/)
      if (phoneMatch) {
        const phone = phoneMatch[0]
        // 使用 FindMember API 查詢（FindMember 回傳 res.data）
        try {
          const member = await FindMember({ shopId: this.shop, phone })
          if (member && member.id) {
            this.$message.success('找到會員')
            this.goProfile(member.id)
          } else {
            // 若 FindMember 回傳陣列風格 [res, err]，嘗試解析
            if (Array.isArray(member)) {
              const [res, err] = member
              if (res && res.id) {
                this.$message.success('找到會員')
                this.goProfile(res.id)
                return
              }
              if (err) this.$message.error('查無此會員')
              else this.$message.error('查無此會員')
            } else {
              this.$message.error('查無此會員')
            }
          }
        } catch (e) {
          console.error('FindMember error', e)
          this.$message.error('查詢會員時發生錯誤')
        }

        return
      }

      this.$message.error('不可用的 QRCode 或資料格式')
    },
  },
})
</script>

<style lang="postcss" scoped>
.headbar {
  @apply flex items-center bg-white box-border z-[1000];
  @apply py-[28px] px-[50px]  rounded-br-[50px] ;
  box-shadow: 0 4px 6px rgb(95 95 95 / 10%);
}

.brand {
  height: auto;
  max-width: 100%;
}

.el-menu-item {
  border-radius: 0 !important;
  background: #f6f7fe !important;
}

a {
  color: inherit;
  text-decoration: none;
}

.username {
  font-weight: 400;
  font-size: 16px;
  color: #2d271b;
  cursor: pointer;
}

.version {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #6d7281;
  font-weight: 400;
  text-align: end;
  margin: 0 24px 0 40px;
}

.scan-qrcode {
  cursor: pointer;
}

.qrcode-reader__container {
  z-index: 100;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .6);
}

.qrcode-reader--close {
  position: absolute;
  top: 92.5px;
  right: 92.5px;
  width: 35px;
  height: 35px;
  cursor: pointer;
}

.qrcode-reader__label {
  color: white;
  font-size: 25px;
  line-height: 28px;
}

.qrcode-reader__label {
  color: white;
  font-size: 25px;
  line-height: 28px;
}

.qrcode-reader {
  position: relative;
  margin-top: 50px;
  width: 440px !important;
  height: 440px !important;
}

.qrcode-reader__prompt {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: white;
  background-color: rgba(0, 0, 0, .6);
}

.qrcode-reader__border-tl,
.qrcode-reader__border-tr,
.qrcode-reader__border-bl,
.qrcode-reader__border-br {
  position: absolute;
}

.qrcode-reader__border-tl {
  top: -6px;
  left: -6px;
}

.qrcode-reader__border-tr {
  top: -6px;
  right: -6px;
}

.qrcode-reader__border-bl {
  bottom: -6px;
  left: -6px;
}

.qrcode-reader__border-br {
  bottom: -6px;
  right: -6px;
}
.suspend {
  flex-basis: 100%;
  margin-top: 10px;
}

.right-menu {
  @apply flex items-center gap-[20px];
}
:deep(.locale-changer .el-input) {
  @apply w-[120px];
  .el-input__inner {
    @apply border-none;
  }
}
</style>
